




























import { defineComponent, ref } from "@vue/composition-api";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";
import { useGroups } from "@/hooks/useGroups";
import AddNewGroup from "@/components/AddNewGroup";
import BasePage from "@/components/BasePage";
import CreateGroupModal from "@/components/CreateGroupModal";
import GroupDeleteConfirmation from "@/components/GroupDeleteConfirmation";
import GroupList from "@/components/GroupList";
import GroupMenu from "@/components/GroupMenu";
import PageTitle from "@/components/PageTitle";

export default defineComponent({
  name: "PageGroups",
  components: { GroupDeleteConfirmation, CreateGroupModal, BasePage, PageTitle, GroupList, GroupMenu, AddNewGroup },
  setup() {
    const { groups, getMyGroups } = useGroups();

    const loading = ref(false);
    const showDeleteConfirmation = ref(false);
    const showCreateModal = ref(false);
    const selectedGroup = ref<Group | null>(null);

    const handleCreate = (group: Group) => {
      groups.value.push(group);
    };

    const handleRename = (group: Group) => {
      selectedGroup.value = group;
      showCreateModal.value = true;
    };

    const afterRename = (group: Group) => {
      groups.value = groups.value.map(g => (g.id === group.id ? group : g));
      selectedGroup.value = null;
      showCreateModal.value = false;
    };

    const handleDelete = (group: Group) => {
      selectedGroup.value = group;
      showDeleteConfirmation.value = true;
    };

    const afterDelete = (groupId: string) => {
      groups.value = groups.value.filter(g => g.id !== groupId);
      selectedGroup.value = null;
      showDeleteConfirmation.value = false;
    };

    const onCancel = () => {
      selectedGroup.value = null;
      showCreateModal.value = false;
      showDeleteConfirmation.value = false;
    };

    const getData = async () => {
      try {
        loading.value = true;
        await getMyGroups();
      } finally {
        loading.value = false;
      }
    };

    getData();

    return {
      loading,
      showDeleteConfirmation,
      showCreateModal,
      selectedGroup,
      groups,
      getData,
      handleCreate,
      handleRename,
      handleDelete,
      afterRename,
      afterDelete,
      onCancel,
    };
  },
});
